<template>
  <div class="mdc-layout-grid demo-grid section-privacy-security">
    <h3
      data-aos="fade"
      data-aos-duration="2000"
      id="feature4"
      class="feature mdc-typography--headline3 text-color mb-3"
    >
      Blockchain
    </h3>
    <p
      data-aos="fade"
      data-aos-delay="800"
      data-aos-duration="2000"
      class="mdc-typography--body text-color font-weight-bold"
    >
      Cum ar fi dacă am folosi Blockchain și Contractele Inteligente pentru a
      investi în idei noi în care credem că vor schimba lumea.
    </p>
    <div class="sc-bdVaJa gzDaIA">
      <div class="sc-bYSBpT hkmxGg">
        <div class="sc-elJkPf sc-jtRfpW irZjSt sc-jqCOkK kYTkfe">
          <div class="sc-uJMKN hghFBj">
            <div class="sc-bbmXgH cNbwtG">
              <div class="sc-hMqMXs sc-kkGfuU dfKfyK"></div>
              <div class="sc-hMqMXs sc-kkGfuU dfKfyK"></div>
              <div class="sc-hMqMXs sc-kkGfuU dfKfyK"></div>
            </div>
            <div class="sc-gGBfsJ ljzdgP">Elrond Smart Contract</div>
          </div>
          <div class="sc-jnlKLf bnrTyb">
            <pre style="line-height:1.2rem; color:#fff;">
pragma solidity ^0.4.22;

contract Purchase {
    uint public value;
    address public founder;
    address public investor;
    enum State { Created, Locked, Inactive }
    State public state;

    // Ensure that `msg.value` is an even number.
    // Division will truncate if it is an odd number.
    // Check via multiplication that it wasn't an odd number.
    constructor() public payable {
        founder = msg.sender;
        value = msg.value / 2;
        require((2 * value) == msg.value, "Value has to be even.");
    }

    modifier condition(bool _condition) {
        require(_condition);
        _;
    }

    modifier onlyInvestor() {
        require(
            msg.sender == investor,
            "Only investor can call this."
        );
        _;
    }

    modifier onlyFounder() {
        require(
            msg.sender == founder,
            "Only founder can call this."
        );
        _;
    }
...</pre
            >
          </div>
        </div>
        <div class="sc-elJkPf sc-kTUwUJ fosFTm sc-jqCOkK cieSDv">
          <div class="sc-uJMKN hghFBj">
            <div class="sc-bbmXgH cNbwtG">
              <div class="sc-hMqMXs sc-kkGfuU dfKfyK"></div>
              <div class="sc-hMqMXs sc-kkGfuU dfKfyK"></div>
              <div class="sc-hMqMXs sc-kkGfuU dfKfyK"></div>
            </div>
            <div class="sc-gGBfsJ ljzdgP"></div>
          </div>
          <div class="sc-jnlKLf kKGdSw">
            <amp-img
              layout="fixed"
              width="494"
              height="316"
              src="/img/contracts/education-window-img1.svg"
              class="i-amphtml-element i-amphtml-layout-fixed i-amphtml-layout-size-defined i-amphtml-layout"
              i-amphtml-layout="fixed"
              style="width: 494px; height: 316px;"
              ><img
                decoding="async"
                loading="lazy"
                src="/img/contracts/education-window-img1.svg"
                class="i-amphtml-fill-content i-amphtml-replaced-content"
            /></amp-img>
          </div>
        </div>
        <div class="sc-elJkPf sc-dqBHgY jOCTmV sc-jqCOkK cieSDv">
          <div class="sc-uJMKN hghFBj">
            <div class="sc-bbmXgH cNbwtG">
              <div class="sc-hMqMXs sc-kkGfuU dfKfyK"></div>
              <div class="sc-hMqMXs sc-kkGfuU dfKfyK"></div>
              <div class="sc-hMqMXs sc-kkGfuU dfKfyK"></div>
            </div>
            <div class="sc-gGBfsJ ljzdgP"></div>
          </div>
          <div class="sc-jnlKLf kKGdSw">
            <amp-img
              layout="fixed"
              width="538"
              height="204"
              src="/img/contracts/education-window-img2.svg"
              style="margin: 90px 0px 35px; width: 538px; height: 204px; --loader-delay-offset:600ms !important;"
              class="i-amphtml-element i-amphtml-layout-fixed i-amphtml-layout-size-defined i-amphtml-layout"
              i-amphtml-layout="fixed"
              ><img
                decoding="async"
                loading="lazy"
                src="/img/contracts/education-window-img2.svg"
                class="i-amphtml-fill-content i-amphtml-replaced-content"
            /></amp-img>
          </div>
        </div>
      </div>
      <div class="sc-htpNat fKpagx">
        <div class="sc-bwzfXH kDkDTl">
          <div class="sc-fYxtnH jEyDZQ">
            <div
              style="position:relative;z-index:11"
              class="sc-jKJlTe hHFiqn sc-kGXeez leDsNz"
            >
              Investitorii apelează la internet pentru a descoperii noi
              fondatori și a-și crește portofoliul de investiții.
            </div>
          </div>
          <div class="sc-elJkPf sc-gxMtzJ IsPHX sc-jqCOkK cieSDv">
            <div class="sc-uJMKN hghFBj">
              <div class="sc-bbmXgH cNbwtG">
                <div class="sc-hMqMXs sc-kkGfuU dfKfyK"></div>
                <div class="sc-hMqMXs sc-kkGfuU dfKfyK"></div>
                <div class="sc-hMqMXs sc-kkGfuU dfKfyK"></div>
              </div>
              <div class="sc-gGBfsJ ljzdgP">Contract</div>
            </div>
            <div class="sc-jnlKLf dqrwCj">
              <div
                style="margin:0 70px 30px"
                class="sc-gisBJw kDlVKO sc-fAjcbJ kLCugD"
              >
                <div
                  class="sc-caSCKo WvgYD"
                  style="animation-name:hEaYzb;animation-delay:1.94s"
                >
                  <div class="sc-hMqMXs sc-kEYyzF eFcqKN"></div>
                </div>
                <div
                  class="sc-caSCKo WvgYD"
                  style="animation-name:gRWtZR;animation-delay:1.58s"
                >
                  <div class="sc-hMqMXs sc-kkGfuU cjCtpH"></div>
                </div>
                <div
                  class="sc-caSCKo WvgYD"
                  style="animation-name:jFgoMS;animation-delay:1.58s"
                >
                  <div class="sc-hMqMXs sc-kkGfuU dCMOku"></div>
                </div>
                <div
                  class="sc-caSCKo WvgYD"
                  style="animation-name:kjJUlo;animation-delay:1.64s"
                >
                  <div class="sc-hMqMXs sc-kkGfuU eVXYFo"></div>
                </div>
                <div
                  class="sc-caSCKo WvgYD"
                  style="animation-name:brhekq;animation-delay:1.58s"
                >
                  <div class="sc-hMqMXs sc-kEYyzF msuNL"></div>
                </div>
                <div
                  class="sc-caSCKo WvgYD"
                  style="animation-name:gnNzle;animation-delay:1.16s"
                >
                  <div class="sc-hMqMXs sc-kkGfuU fJGVqx"></div>
                </div>
                <div
                  class="sc-caSCKo WvgYD"
                  style="animation-name:euwsgw;animation-delay:1.58s"
                >
                  <div class="sc-hMqMXs sc-kkGfuU iOSDzH"></div>
                </div>
              </div>
              <div class="sc-kGXeez cWjKrq">0xb1Afb3...</div>
              <div class="sc-kGXeez bVtHOt">Felicitări 🎉</div>
              <div style="margin-bottom:35px" class="sc-kGXeez bVtHOt">
                Ați semnat contractul!
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SmartContracts'
}
</script>

<style>
.gzDaIA {
  margin: auto;
  position: relative;
}
.IsPHX,
.fosFTm,
.irZjSt,
.jOCTmV {
  transition: transform 0.2s ease-out;
  position: absolute;
}
.irZjSt {
  z-index: 3;
  top: 100px;
  left: 0;
}
.fosFTm {
  z-index: 2;
  top: -30px;
  left: 25%;
}
.jOCTmV {
  z-index: 1;
  top: 50px;
  left: 40%;
}
.kYTkfe {
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(85, 23, 208, 0.23);
  border-radius: 10px;
  width: 600px;
  position: relative;
  /* z-index: 1; */
}
.bnrTyb {
  background: #5517d0;
  color: #fff;
  flex-grow: 1;
}
.eVIaVT {
  background: #ede4ff;
  color: #5517d0;
}
.cieSDv:before,
.flEQic:before,
.kYTkfe:before,
.kjNXAw:before {
  display: block;
  width: 100%;
  height: 100%;
  content: '';
  background: url(/img/contracts/noise.svg) top right repeat-y;
  top: 15px;
  right: -9px;
  position: absolute;
  z-index: -1;
  border-radius: 10px;
}
.hghFBj {
  border-bottom: 2px solid rgba(85, 23, 208, 0.23);
  border-radius: 10px 10px 0 0;
  text-align: center;
  background: #fff;
  position: relative;
  height: 38px;
}
.cNbwtG {
  position: absolute;
  left: 10px;
  display: flex;
  height: 100%;
  align-items: center;
}
.cNbwtG > div {
  margin: 0 3px;
}
.dfKfyK {
  display: block;
  width: 8px;
  height: 8px;
  border-color: #5517d0;
  border-style: solid;
  background: #5517d0;
  border-radius: 100em;
}
.kKGdSw {
  background: #fff;
  flex-grow: 1;
}
.IsPHX:hover,
.fosFTm:hover,
.irZjSt:hover,
.jOCTmV:hover {
  z-index: 10;
  transform: translateY(-10px);
}
.hkmxGg {
  height: 350px;
  position: relative;
  margin-top: 60px;
  margin-bottom: 50%;
}
.bnrTyb,
.dqrwCj,
.kKGdSw {
  border-radius: 0 0 10px 10px;
  padding: 30px 25px;
}
.i-amphtml-layout-size-defined .i-amphtml-fill-content {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
.i-amphtml-replaced-content,
.i-amphtml-screen-reader {
  padding: 0 !important;
  border: none !important;
}
.i-amphtml-blurry-placeholder,
.i-amphtml-fill-content {
  display: block;
  height: 0;
  max-height: 100%;
  max-width: 100%;
  min-height: 100%;
  min-width: 100%;
  width: 0;
  margin: auto;
}
.i-amphtml-layout-fixed,
[layout='fixed'][width][height]:not(.i-amphtml-layout-fixed) {
  display: inline-block;
  position: relative;
}
.i-amphtml-layout-size-defined {
  overflow: hidden !important;
}
.fKpagx,
.iXVVIE,
.kdmCtF {
  flex: 1 1 auto;
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  position: relative;
  margin: -16px;
}
.kDkDTl {
  width: 50%;
  margin-right: calc(100% / 12 * 3);
}
.cTTlZj,
.exYTuY,
.fyJikJ,
.gRfZcJ,
.jTSwSN,
.kDkDTl,
.lpuuRL {
  position: relative;
  display: inline-block;
  vertical-align: top;
  padding: 16px;
  zoom: 1;
}
.leDsNz {
  color: #ff005b;
  font-family: Oswald;
}
.hHFiqn {
  font-size: 56px;
  line-height: 1.17em;
}
.ljzdgP {
  font-size: 12px;
  line-height: 38px;
  font-weight: 600;
  padding: 0 60px;
  text-overflow: ellipsis;
  color: #5517d0;
}
.IsPHX {
  top: -50%;
  right: -100%;
  text-align: center;
  z-index: 3;
}
.kLCugD {
  width: 177px;
  height: 201px;
}
.dqrwCj {
  background: #fff0e2;
  flex-grow: 1;
}
.bVtHOt {
  font-size: 33px;
  color: #ffa900;
  line-height: 42px;
}
.cWjKrq {
  font-family: Oswald;
  color: #ffa900;
  line-height: 24px;
}
</style>
